import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext/AuthContext';
import { subscribeUnreadCount, badgeText } from '../../services/notificationService';

/* NotificationBell — the staff header's way into the notification center
   (card VVo3vlre9wI4gUa1KTzI, 2026-09-22). Lives in BOTH staff chromes
   (PortalLayout for admins, PortalSpaceChrome for teachers and the private
   spaces), so it is on every staff page.

   A LINK, not a popover. The page is the place to read, scroll back and mark
   read/unread; a dropdown would duplicate it at a size too small to read
   comfortably, and an anchored panel in the sticky topbar is exactly the
   stacking/clipping trouble CLAUDE.md records for .wt-dueset.

   The count is never colour-only: the badge carries the NUMBER, and the link's
   accessible name says it ("Notifications, 3 unread"). Nothing is hover-only.

   Staff roles only. A read failure (offline, rules) hides the badge rather than
   showing a wrong number; the link itself always works. */
const STAFF = new Set(['employee', 'admin']);

function NotificationBell() {
	const { currentUser, userProfile } = useAuth();
	const uid = currentUser?.uid || null;
	const isStaff = STAFF.has(userProfile?.role) || userProfile?.owner === true;
	const [count, setCount] = useState(0);

	useEffect(() => {
		if (!uid || !isStaff) return undefined;
		const unsub = subscribeUnreadCount(uid, setCount, (err) => {
			console.error('Notification count failed:', err);
			setCount(0);
		});
		return () => unsub && unsub();
	}, [uid, isStaff]);

	if (!uid || !isStaff) return null;

	const badge = badgeText(count);
	return (
		<Link
			to='/portal/work/notifications'
			className={`portal-topbar__bell${badge ? ' has-unread' : ''}`}
			aria-label={badge ? `Notifications, ${count} unread` : 'Notifications'}
			title={badge ? `${count} unread` : 'Notifications'}>
			<i className='fa-sharp fa-solid fa-bell' aria-hidden='true' />
			{badge && <span className='portal-topbar__bell-badge'>{badge}</span>}
		</Link>
	);
}

export default NotificationBell;
